import React from 'react'
import Heading from '../../../../../components/heading/Heading';
import { HEADING } from '../../../../../components/heading/constants/constants';
import commonStyles from "../../AddPayerCommonStyles.styles"
import CardWIconTitleAndButton from '../../../../../components/card/CardWIconTitleAndButton/CardWIconTitleAndButton';
import { CHOOSE_METHOD_CARDS } from './constants/constants';
import { componentKey, setMethodType } from '../../AddPayerSlice';
import { useDispatch, useSelector } from 'react-redux';

export default function GetMethod({ onCardClickCb = () => { }, payerLabel = 'Payer', methodType = "", heading = `How would you like to add your ${payerLabel}s?`, cardsData = CHOOSE_METHOD_CARDS, onClickLinkButtonTextCb = () => { } }) {

    return (
        <>
            <div style={commonStyles.container}>
                <div>
                    <Heading type={HEADING.H1}>{heading}</Heading>
                    <p>We will prefill this data when you start eFiling forms. This will help you save a lot of time!</p>
                </div>

                <div style={commonStyles.cardsGroupContainer}>
                    {
                        cardsData.map((card, idx) => (
                            <div key={idx} style={commonStyles.cardContainer} onClick={() => onCardClickCb(card)}>
                                <CardWIconTitleAndButton
                                    title={card.title}
                                    icon={card.icon}
                                    subText={card.subText}
                                    linkButtonText={card.linkButtonText}
                                    customStyles={commonStyles.individualCardStyle}
                                    isHighlighted={methodType === card.name ? true : false}
                                    onClickLinkButtonTextCb={onClickLinkButtonTextCb}
                                />
                            </div>)
                        )
                    }
                </div>
            </div>
        </>
    )
}